<template>
  <div id="app">
    <search-bar ref="searchBarComponent">
      <div slot="search-tool">
      </div>
      <div slot="search-cont">
        <div class="item" style="width: 20%;">
          <div class="item-label">操作类型</div>
          <el-select v-model="info.operatetype" size="small" slot="prepend" placeholder="请选择操作类型" @change="getTableData">
            <el-option label="全部" value=""></el-option>
            <el-option label="新录" value="1"></el-option>
            <el-option label="继录" value="2"></el-option>
            <el-option label="接手" value="3"></el-option>
            <el-option label="转推" value="4"></el-option>
            <el-option label="更换" value="5"></el-option>
            <el-option label="修改面试信息" value="6"></el-option>
            <el-option label="设置接送信息" value="7"></el-option>
            <el-option label="置面试结果" value="8"></el-option>
          </el-select>
        </div>

        <div class="item" style="width: 20%;">
          <div class="item-label">操作人员类型</div>
          <el-select v-model="info.type" size="small" slot="prepend" placeholder="请选择操作人员类型" @change="getTableData">
            <el-option label="全部" value=""></el-option>
            <el-option label="小程序" value="1"></el-option>
            <el-option label="后台" value="2"></el-option>
            <el-option label="系统" value="3"></el-option>
          </el-select>
        </div>

        <div class="item" >
          <div class="item-label">操作时间</div>
          <el-date-picker v-model="info.begintimes" type="daterange" range-separator="-" start-placeholder="操作时间"
            end-placeholder="操作时间" value-format="yyyy-MM-dd" size="mini" @change="timeChange"></el-date-picker>
        </div>

        <div class="item" style="width: 50%;margin-top: 20px;">
          <div class="item-label">关键词搜索</div>
          <div style="width: 300px;">
            <el-input placeholder="请输入内容" v-model="info.key" class="input-with-select" size="small"  @keyup.enter.native='searchResume'>
              <el-select v-model="info.key_type" slot="prepend" placeholder="请选择" style="width: 130px" size="small">
                <el-option label="姓名" value="1"></el-option>
                <el-option label="电话号码" value="2"></el-option>
                <el-option label="操作内容" value="3"></el-option>
                <el-option label="操作人员" value="4"></el-option>
                <el-option label="公司" value="5"></el-option>
              </el-select>
              <el-button slot="append" icon="el-icon-search" @click='searchResume' size="small"></el-button>
            </el-input>
          </div>
        </div>

      </div>
    </search-bar>

    <div class="table">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="adminname" label="操作人员"></el-table-column>
        <el-table-column prop="resume_name" label="姓名"></el-table-column>
        <el-table-column prop="telephone" label="电话"></el-table-column>
        <el-table-column prop="type" label="操作人员类型">
          <template slot-scope='{row}'>
            <span v-if="row.type == 1">小程序</span>
            <span v-if="row.type == 2">后台</span>
            <span v-if="row.type == 3">系统</span>
          </template>
        </el-table-column>
        <el-table-column prop="operatetype_cn" label="操作类型"></el-table-column>
        <el-table-column prop="addtime" label="作时间"></el-table-column>
        <el-table-column prop="content" label="操作内容">
          <template slot-scope='{row}'>
            <el-popover placement="top-start" title="操作内容" width="200" trigger="hover" :content="row.content">
              <div slot="reference" class='content'>{{row.content}}</div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <div class="totalNumber">查询出{{total}}条数据</div>
      <el-pagination layout="prev, pager, next" :total="total" @current-change='paginationChange'> </el-pagination>
    </div>
  </div>
</template>

<script>
  import Message from '@/utils/message.js';
  export default {
    data() {
      return {
        info: {
          begintimes: [],
          key_type: '',
          key: '',
          operatetype: '',
          type: '',
          begintime: '',
          endtime: '',
        },
        tableData: [],
        total: 1
      }
    },

    mounted() {
      this.getTableData()
    },

    methods: {
    timeChange(val) {
      if(val){
        this.info.begintime = val?val[0]:''
        this.info.endtime = val?val[1]:''
      }else{
        this.info.begintime = ''
        this.info.endtime = ''
      }
      this.info.page = 1
      this.getTableData()
    },

      searchResume() {
        if(!this.info.key_type){return Message.warning('请选择搜索类型')}
        this.info.page = 1
        this.getTableData()
      },

      paginationChange(val) {
        this.info.page = val
        this.getTableData()
      },


      getTableData() {
        this.gets('oasystem/operatelist', this.info).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        })
      }
    }
  }
</script>

<style scoped>
  .totalNumber {
    height: 50px;
    padding: 0 20px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .pagination {
    text-align: center;
    width: 100%;
    background: #fff;
    height: 50px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .table {
    margin: 20px 0;
    background: #fff;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .content {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/view/oasystem/oaoperatelist.vue